const gloabalsReducer = (state = {
  lang: 'en',
  meta: {
    title: 'Lenspire',
    description: 'Description',
    canonical: '/',
    meta: {
      charset: 'utf-8',
      name: {
        keywords: '',
      },
    },
  },
  social: {
    yt: '',
    vimeo: '',
    fb: '',
    twitter: '',
    instagram: '',
    google: '',
  },
  error: '',
}, action) => {
  switch (action.type) {
    case 'SET_LANG':
      return {
        ...state,
        lang: action.lang,
      };
    case 'UPDATE_META':
      return {
        ...state,
        meta: { ...action.meta },
      };
    case 'SET_ERROR':
      return {
        ...state,
        error: action.error,
      };
    case 'GET_GLOBALS':
      return {
        ...state,
        social: action.globals.some,
      };
    // case 'IS_LOADING':
    //   return {
    //     ...state,
    //     isLoading: action.isLoading,
    //   };
    default:
      return {
        ...state,
      };
  }
};

export default gloabalsReducer;



// WEBPACK FOOTER //
// ./frontend/js/Base/Reducers/globalsReducer.jsx